export function sendQueryToServer(searchUrl: string, searchModel:any): Promise<any> {
    const url = searchUrl;
    return fetch(url, {
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(searchModel),
        credentials: 'same-origin',
        method: 'POST'
    }).then(response => {
        return response.json();
    }).catch(response => {
        return response.json();
    });
};